import { render, staticRenderFns } from "./contactInfo.vue?vue&type=template&id=ca91feea&scoped=true&"
import script from "./contactInfo.vue?vue&type=script&lang=js&"
export * from "./contactInfo.vue?vue&type=script&lang=js&"
import style0 from "./contactInfo.vue?vue&type=style&index=0&id=ca91feea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca91feea",
  null
  
)

export default component.exports